import axiosInstance from '../../utils/axiosInstance';
const API_URL = process.env.REACT_APP_API_PRODUCT;

export const getProducts = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

export const getActiveProducts = async () => {
  const response = await axiosInstance.get(`${API_URL}/active`);
  return response.data;
};

export const createProduct = async (Product) => {
  const response = await axiosInstance.post(API_URL, Product);
  return response.data;
};

export const updateProduct = async (id, Product) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, Product);
  return response.data;
};

export const deleteProduct = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

export const markProductInactive = async (id, date) => {
  const response = await axiosInstance.put(`${API_URL}/mark-inactive/${id}`, {date})
}

export const createBulkProducts = async (product) => {
  const response = await axiosInstance.post(`${API_URL}/import`, product);
  return response.data;
};
